import React from 'react';

/**
 * Lightweight markdown parser supporting:
 * ## heading -> h4, ### heading -> h5, **bold** -> strong,
 * - item -> ul/li, double newline -> paragraphs
 */
export function simpleMarkdown(text) {
    if (!text) return '';

    const lines = text.split('\n');
    const htmlParts = [];
    let inList = false;
    let currentParagraph = [];

    const flushParagraph = () => {
        if (currentParagraph.length > 0) {
            const content = currentParagraph.join(' ').trim();
            if (content) {
                htmlParts.push(`<p>${inlineFormat(content)}</p>`);
            }
            currentParagraph = [];
        }
    };

    const flushList = () => {
        if (inList) {
            htmlParts.push('</ul>');
            inList = false;
        }
    };

    for (const line of lines) {
        const trimmed = line.trim();

        // Empty line — flush paragraph
        if (trimmed === '') {
            flushParagraph();
            flushList();
            continue;
        }

        // ## Heading
        if (trimmed.startsWith('### ')) {
            flushParagraph();
            flushList();
            htmlParts.push(`<h5>${inlineFormat(trimmed.slice(4))}</h5>`);
            continue;
        }
        if (trimmed.startsWith('## ')) {
            flushParagraph();
            flushList();
            htmlParts.push(`<h4>${inlineFormat(trimmed.slice(3))}</h4>`);
            continue;
        }

        // - list item
        if (trimmed.startsWith('- ')) {
            flushParagraph();
            if (!inList) {
                htmlParts.push('<ul>');
                inList = true;
            }
            htmlParts.push(`<li>${inlineFormat(trimmed.slice(2))}</li>`);
            continue;
        }

        // Regular text — accumulate for paragraph
        if (inList) {
            flushList();
        }
        currentParagraph.push(trimmed);
    }

    flushParagraph();
    flushList();

    return htmlParts.join('');
}

function inlineFormat(text) {
    // Escape HTML entities
    let result = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    // **bold**
    result = result.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    return result;
}

export function TextBlock({ data }) {
    const content = data?.content || '';

    if (!content) {
        return null;
    }

    return (
        <div
            className="text-block"
            dangerouslySetInnerHTML={{ __html: simpleMarkdown(content) }}
        />
    );
}
